import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles(theme => ({
  teste: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px"
  }
}))
